import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { DESTINATIONS } from "@/data/content";

export default function Destinations() {
  return (
    <section className="bg-[#F7F5F0] py-10 md:py-12 px-5 md:px-12 lg:px-24" data-testid="destinations-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-6 mb-5 md:mb-6">
        <div>
          <p className="tcp-overline text-[#C29B62] mb-2 md:mb-4">Popular Destinations</p>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-tight md:leading-none text-[#1C1C1C]">
            Where <em className="italic">stories</em> are <br className="hidden md:block" /> waiting to be written.
          </h2>
        </div>
        <p className="text-[#666460] max-w-md text-sm md:text-base leading-relaxed">
          Hand-picked routes from US gateways — flown in cabins that feel like an extension of the destination itself.
        </p>
      </div>

      {/* Mobile: 2 × 2 grid (smaller cards) → Tablet 2-col → Desktop 4-col,
          all tiles share the same 3:4 aspect ratio. */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
        {DESTINATIONS.map((d) => (
          <Link
            key={d.code}
            to={`/destinations/${d.code}`}
            data-testid={`dest-${d.code}`}
            className="group relative overflow-hidden lift cursor-pointer aspect-[3/4] md:aspect-[5/6]"
          >
            <img
              src={d.img}
              alt={`${d.city}, ${d.country}`}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute inset-0 p-3 md:p-7 flex flex-col justify-end text-[#F7F5F0]">
              <p className="tcp-overline text-[#C29B62] text-[10px] md:text-xs">{d.country}</p>
              <div className="flex items-end justify-between mt-1.5 md:mt-2 gap-2">
                <h3 className="font-serif text-xl md:text-4xl tracking-tight leading-none">{d.city}</h3>
                <ArrowUpRight size={20} className="text-[#C29B62] shrink-0 hidden md:block opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all md:w-7 md:h-7" />
              </div>
              <p className="text-[11px] md:text-sm text-[#A09E9A] mt-1.5 md:mt-3 leading-tight">
                From <span className="text-[#F7F5F0] font-semibold">${d.from.toLocaleString()}</span>
                <span className="hidden sm:inline"> · Business Class</span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
